import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
      {categories.map((cat, idx) => (
        <a
          key={idx}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group relative flex flex-col rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer bg-background-50 hover:shadow-sm"
        >
          <div className="relative w-full h-[140px] sm:h-[160px] md:h-[180px] overflow-hidden">
            <div
              className="absolute inset-0 bg-cover bg-center object-top transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: `url('${cat.imageUrl}')` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-semibold leading-tight drop-shadow-sm">
                {cat.name}
              </span>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}